import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const CRMCustomSettingsComponent = ({ selectCRMSettings, handleInnerFormChange }: any) => {

    return (
        <>
        <AccordionContainer
            child={
            <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                <InputContainer
                    label="Default OrganizationUnit Enabled"
                    name="IsDefaultOrganizationUnitEnabled"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event,
                        'CustomSettings.IsDefaultOrganizationUnitEnabled',
                        selectCRMSettings?.CustomSettings
                    )
                    }}
                    type="checkbox"
                    value={selectCRMSettings?.CustomSettings?.IsDefaultOrganizationUnitEnabled}
                />  
                <InputContainer
                    label="Default PriceBook Enabled"
                    name="IsDefaultPriceBookEnabled"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event,
                        'CustomSettings.IsDefaultPriceBookEnabled',
                        selectCRMSettings?.CustomSettings
                    )
                    }}
                    type="checkbox"
                    value={selectCRMSettings?.CustomSettings?.IsDefaultPriceBookEnabled}
                /> 
            </div>
            }
        expandedPanel="Custom Settings"
        headerTitle="Custom Settings"
        />
        <AccordionContainer
            child={
            <div className=' grid md:grid-cols-3 lg:grid-cols-3 gap-3'>
                <InputContainer
                    label="Create Prospect From Company Enabled"
                    name="IsCreateProspectFromCompanyEnabled"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event,
                        'ProspectSettings.IsCreateProspectFromCompanyEnabled',
                        selectCRMSettings?.ProspectSettings
                    )
                    }}
                    type="checkbox"
                    value={selectCRMSettings?.ProspectSettings?.IsCreateProspectFromCompanyEnabled}
                />  
                <InputContainer
                    label="Create Prospect From Contact Enabled"
                    name="IsCreateProspectFromContactEnabled"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event,
                        'ProspectSettings.IsCreateProspectFromContactEnabled',
                        selectCRMSettings?.ProspectSettings
                    )
                    }}
                    type="checkbox"
                    value={selectCRMSettings?.ProspectSettings?.IsCreateProspectFromContactEnabled}
                /> 
            </div>
            }
        expandedPanel="Prospect Settings"
        headerTitle="Prospect Settings"
        />
        <AccordionContainer
            child={
            <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                <InputContainer
                    label="Sales Order Number Prefix"
                    name="SalesOrderNumberPrefix"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event.target.value,
                        'SalesOrderSettings.SalesOrderNumberPrefix',
                        selectCRMSettings?.SalesOrderSettings
                    )
                    }}
                    type="text"
                    value={selectCRMSettings?.SalesOrderSettings?.SalesOrderNumberPrefix}
                />
                <InputContainer
                    label="Invoice Number Prefix"
                    name="InvoiceNumberPrefix"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event.target.value,
                        'SalesOrderSettings.InvoiceNumberPrefix',
                        selectCRMSettings?.SalesOrderSettings
                    )
                    }}
                    type="text"
                    value={selectCRMSettings?.SalesOrderSettings?.InvoiceNumberPrefix}
                />
            </div>
            }
        expandedPanel="Sales Order Settings"
        headerTitle="Sales Order Settings"
        />
        <AccordionContainer
            child={
            <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                <InputContainer
                    label="Sales Quote Number Prefix"
                    name="SalesQuoteNumberPrefix"
                    onValueChange={(event: any) => {
                    handleInnerFormChange(
                        event.target.value,
                        'SalesQuoteSettings.SalesQuoteNumberPrefix',
                        selectCRMSettings?.SalesQuoteSettings
                    )
                    }}
                    type="text"
                    value={selectCRMSettings?.SalesQuoteSettings?.SalesQuoteNumberPrefix}
                />
            </div>
            }
        expandedPanel="Sales Quote Settings"
        headerTitle="Sales Quote Settings"
        />
        </>
  )
}
export default CRMCustomSettingsComponent;
